import { ModelClassEnum } from '@api';
import { DataCollectionInputs } from '@types';

export const getTabularModelClass = (inputs?: Partial<DataCollectionInputs>): ModelClassEnum | null => {
  const dataset = inputs?.dataPipeline?.dataset as { modelClass?: ModelClassEnum } | undefined;

  if (dataset?.modelClass) {
    return dataset.modelClass;
  }

  const fallbackModelType = inputs?.modelType as ModelClassEnum | undefined;
  return fallbackModelType ?? null;
};
